<template>
  <transition name="message-fade">
    <div v-if="visible" :class="wrapClasses">
      <img class="message_img" :src="typeImg"/>
      <span class="">
          {{message}}
        </span>
    </div>
  </transition>
</template>

<script>
  // import {getNextZIndex} from '../../services/sharedService'

  const prefixCls = 'message'
  export default {
    name: 'message',
    data () {
      return {
        visible: false,
        type:'info',
        message: '',
        duration: 1000,
        zIndex:-1,
      }
    },
    computed:{
      typeImg(){
        return require(`../assets/message/${this.type}.svg`);
      },
      wrapClasses(){
        return[
          `${prefixCls}`,
          `${prefixCls}-${this.type}`
        ]
      }
    },
    methods: {
      setTimer() {
        setTimeout(() => {
          this.close() // 3000ms之后调用关闭方法
        }, this.duration)
      },
      close() {
        this.visible = false
        setTimeout(() => {
          this.$destroy(true)
          this.$el.parentNode.removeChild(this.$el) // 从DOM里将这个组件移除
        }, 500)
      }
    },
    mounted() {
      this.setTimer() // 挂载的时候就开始计时，3000ms后消失
    },
    created() {
      // this.zIndex = getNextZIndex();
    },
  }
</script>

<style scoped lang="less">
  .message-fade-enter-active, .message-fade-leave-active {
    transition: all .3s ease;
  }
  .message-fade-enter, .message-fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    transform: translateY(-20px);
    opacity: 0;
  }
  .message{
    position: fixed;
    top: 62px;
    /*right: 36%;*/
    left:50%;
    transform: translateX(-50%);
    /*width: 22%;*/
    min-width: 380px;
    box-sizing: border-box;
    border: 1px solid #ebeef5;
    border-radius:4px;
    padding: 15px 15px 15px 20px;
    color: #616060;
    font-size: 14px;
    line-height: 1;
    z-index: 100000;
  }
  .message-close{
    position: absolute;
    top: 25%;
    right: 10px;
    color: rgba(153, 152, 152, 0.774);
    cursor: pointer;
    font-size: 17px;
  }
  .message-close:hover{
    color: #0c0c0c;
  }
  .message_img{
    display: inline-block;
    border-radius: 50%;
    width:13px;
    vertical-align: baseline;
    line-height: 1;
    margin-right: 10px;
  }
  .message-success{
    background: #f0f9eb;
    color: #67c23a;
    border-color: #e1f3d8;
  }
  .message-info{
    color: #909399;
    background: #edf2fc;
    border-color: #ebeef5;
  }
  .message-warning{
    color: #e6a23c;
    background: #fdf6ec;
    border-color: #faecd8;
  }
  .message-error{
    background: #fef0f0;
    border-color: #fde2e2;
    color: #f56c6c;
  }
</style>




// WEBPACK FOOTER //
// src/messgae/message.vue